import { observable, makeObservable } from 'mobx';
export class QueryStore {
    constructor(services, autocomplete, search) {
        const observables = {};
        if (search?.query) {
            this.query = new Query(services.urlManager, search.query);
            observables.query = observable;
        }
        if (autocomplete?.correctedQuery && autocomplete.query) {
            this.originalQuery = new Query(services.urlManager, autocomplete.query);
            observables.originalQuery = observable;
        }
        makeObservable(this, observables);
    }
}
class Query {
    constructor(urlManager, query) {
        this.string = query;
        this.url = urlManager.set({ query: this.string });
        makeObservable(this, {
            string: observable,
        });
    }
}
